import PromoBlockSection from './promo-block-section';

export default PromoBlockSection;
